<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>我的仓库</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="仓库">
                    <el-select v-model="listQuery.houseIdList" clearable placeholder="请选择仓库" filterable multiple>
                        <el-option v-for="(item,index) in houseList" :key="index" :label="item.houseName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="商品SKU">
                    <el-input v-model="listQuery.skuCode" placeholder="请输入商品SKU" clearable></el-input>
                </el-form-item>

                <el-form-item label="商品名称">
                    <el-input v-model="listQuery.skuName" placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch()">查询</el-button>
                    <el-button  icon="el-icon-download" type="primary" plan @click="downHouseStock()">导出</el-button>
                    <!-- <el-button icon="el-icon-plus" type="primary" plan @click="addWarehouse">新增仓库</el-button> -->
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

                <el-table-column prop="houseName" label="仓库名称" width="160" fixed="left"></el-table-column>
                <el-table-column prop="skuCode" label="商品SKU"></el-table-column>
                <el-table-column prop="skuName" label="商品名称"></el-table-column>
                <el-table-column prop="propertyValue" label="商品属性"></el-table-column>
                <el-table-column prop="stockNumber" label="总库存数"></el-table-column>
                <el-table-column prop="stockLockNumber" label="占用库存数"></el-table-column>
                <el-table-column prop="stockInNumber" label="总入库数"></el-table-column>
                <el-table-column prop="stockOutNumber" label="总出库数"></el-table-column>

                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

                <el-table-column prop label="操作" fixed="right" width="180px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSotckSub(scope.row)" size="mini">库存详情</el-button>
                        <el-button type="text" @click="goStockLog(scope.row)" size="mini">出入库记录</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="库存详情" :visible.sync="showSubInfo" width="1200px" :close-on-click-modal="false" center>
            <el-table :data="stockSubInfoList" border style="width: 100%" class="table">
                <el-table-column prop="houseName" label="仓库名称"></el-table-column>
                <el-table-column prop="skuCode" label="商品SKU"></el-table-column>
                <el-table-column prop="skuName" label="商品名称"></el-table-column>
                <el-table-column prop="snCode" label="商品SN码"></el-table-column>
                <el-table-column prop="costPrice" label="商品成本价"></el-table-column>
                <el-table-column prop="stockNumber" label="库存数"></el-table-column>
                <el-table-column prop="stockInNumber" label="入库数"></el-table-column>
                <el-table-column prop="stockOutNumber" label="出库数"></el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showSubInfo = false">关闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import url from "@/script/baseUrl.js";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
export default {
    components: { Pagination },
    data() {
        return {
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                skuCode: "",
                skuName: "",
                cityId: "",
                houseIdList: [],
            },
            cityList: [],
            houseList: [],
            tempHouseList: [],
            stockSubInfoList: [],
            showSubInfo: false,
        };
    },
    created() {
        // this.querySearch();
        this.getAllCity();
        this.getAllHouse();
    },
    methods: {
        goStockLog(row) {
            this.$router.push({
                path: "/warehouseCenter/warehouseManage/stocklogList",
                query: {
                    skuCode: row.skuCode,
                    houseId: row.houseId,
                },
            });
        },
        cityChange(cityId) {
            this.listQuery.houseIdList = [];
            let temparr = [];
            this.tempHouseList.filter((item) => {
                if (item.cityId == cityId) {
                    temparr.push(item);
                }
            });
            this.houseList = temparr;
        },

        showSotckSub(row) {
            //详情
            this.showSubInfo = true;
            let req = {
                houseId: row.houseId,
                skuCode: row.skuCode,
            };
            wmsApi.$axiosWmsHouseStockstockSubInfo(req).then((res) => {
                if (res.data.errno == 0) {
                    this.stockSubInfoList = res.data.data;
                }
            });
        },

        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            this.listQuery.houseIds = this.listQuery.houseIdList.join(",");
            this.listQuery.isExport=false;
            wmsApi.$axiosWmsHouseStockStockList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        downHouseStock(){
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            this.listQuery.houseIds = this.listQuery.houseIdList.join(",");
            //  this.listQuery.isExport=true;

              let params ="/wmsHouseStock/stockListExport?token="
               +window.localStorage.getItem("token")
              +`&isExport=true&pageSize=${this.pageSize}&pageNum=${this.currentPage}&cityId=${this.listQuery.cityId}&skuCode=${this.listQuery.skuCode}&houseIdList=${this.listQuery.houseIdList}`;
            window.open( url.salaryUrl + params);
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getAllHouse() {
            //仓库下拉框
            wmsApi
                .$axiosgetAllHouse({ sysUserId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.houseList = res.data.data;
                        this.tempHouseList = res.data.data;
                        if (this.houseList.length > 0) {
                            let arr = [];
                            this.houseList.forEach((e) => {
                                if (e.mark) {
                                    arr.push(e.id);
                                }
                            });
                            console.log(arr);
                            this.listQuery.houseIdList = arr;
                            this.querySearch();
                        }
                    }
                });
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
